import { useEffect } from "react";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { stopChimeStreams } from "@core/features/video/utils/stopChimeStreams";
import { stopAllMediaTracks } from "@core/features/video/utils/stopAllMediaTracks";

/**
 * Render-null component that releases camera/mic hardware and tears down
 * the Chime session when VideoLayout unmounts (e.g., SPA navigation to a
 * non-video page).
 *
 * stopAllMediaTracks() runs first and is synchronous — it calls
 * track.stop() directly on every MediaStream-backed element in the DOM,
 * releasing hardware immediately. The subsequent async calls
 * (stopChimeStreams, meetingManager.leave) are fire-and-forget SDK-level
 * cleanup that may or may not complete before the provider tree unmounts.
 */
export function VideoLayoutCleanup() {
  const meetingManager = useMeetingManager();

  useEffect(() => {
    return () => {
      // Synchronous: immediately release camera/mic hardware
      stopAllMediaTracks();
      // Async fire-and-forget: clean up SDK state
      stopChimeStreams(meetingManager);
      // Async fire-and-forget: leave the Chime session
      try {
        meetingManager.leave();
      } catch {
        // Best effort
      }
    };
  }, [meetingManager]);

  return null;
}
